import * as React from 'react';
import { TeamRowData } from '../types';
import { Avatar } from 'wix-style-react';

interface Props {
  rowData: TeamRowData;
}

export const TeamContributorImage: React.FC<Props> = ({ rowData }) => {
  return (
    <Avatar
    dataHook="team-image"
    ariaLabel={`Avatar for ${'placeholder name'}`}
    color={undefined}
    name={rowData.accountName}
    imgProps={{ src: rowData.accountImage }}
    shape="square"
  />
  );
};
